import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Modal, Button, Card, Icon} from 'semantic-ui-react';


export default class DetailVerificator extends Component {
   render() {
      const {nama, username, jabatan, created_at, public_id} = this.props.itemActive;
      
      const extra = (
         <a>
            <Icon name='wait' />
            {created_at}
         </a>
      )
      return (
         <Modal size={'mini'} open={this.props.show} dimmer={"blurring"}>
            <Modal.Content>
               <Card key={public_id} style={{width:'400px'}}
                  header={nama}
                  meta={username}
                  description={jabatan}
                  extra={extra}
               />
            </Modal.Content>
            <Modal.Actions>
               <Button negative onClick={this.props.onClose}>
                  Tutup
               </Button>
            </Modal.Actions>
         </Modal>
      );
   }
}


DetailVerificator.propTypes = {
   onClose: PropTypes.func.isRequired,
   show: PropTypes.bool,
 };


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_user/_userverificator/DetailVerificator.js